/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectRenderGetVideoUrlQueryResponse, ProjectRenderGetVideoUrlPathParams, ProjectRenderGetVideoUrlQueryParams } from "../models/ProjectRenderGetVideoUrl";

export function getProjectRenderGetVideoUrlUrl(id: ProjectRenderGetVideoUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/projects/${id}/render/video-url` as const }  
  return res
}

/**
 * @summary Get signed video URL for the rendered project
 * {@link /projects/:id/render/video-url}
 */
export async function projectRenderGetVideoUrl(id: ProjectRenderGetVideoUrlPathParams["id"], params?: ProjectRenderGetVideoUrlQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectRenderGetVideoUrlQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getProjectRenderGetVideoUrlUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}